// extracted by mini-css-extract-plugin
export default {"root":"billingMethodCard_root__U3XFH","head":"billingMethodCard_head__miC88","active":"billingMethodCard_active__3GO5O","disabled":"billingMethodCard_disabled__1gvVF"};